<template>
  <div class="boutentry">
    <alert :shown="showAlert" :title="alertTitle" :type="alertType" :content="alertContent" />
    <form v-on:submit.prevent="submit" id="boutForm">
      <!-- Event -->
      <div class="form-group">
        <label class="form-label" for="event">Event:</label>
        <select class="form-select" id="event" v-model="event" v-on:change="changeEvent">
          <option value="">Choose an event</option>
          <option v-for="event in events" :value="event.id">
            {{event.name}}: {{new Date(event.date).toLocaleDateString()}}
          </option>
        </select>
      </div>
      <br />

      <!-- Date -->
      <div class="form-group">
        <label class="form-label" for="date">Date:</label>
        <input class="form-input" type="date" id="date" v-model="date" required />
      </div>
      <br />

      <!-- Competitor -->
      <div class="form-group">
        <label class="form-label" for="competitor">Competitor:</label>
        <select class="form-select" id="competitor" v-model="competitor">
          <option v-for="competitor in competitors" :value="competitor.originalid ? competitor.originalid : competitor.id">
            {{competitor.lastname}}, {{competitor.firstname}}
          </option>
        </select>
      </div>
      <a href="#" v-on:click.prevent="newCompetitor">New competitor</a>
      <div id="newCompetitor" v-bind:style="{ display : showCompetitor }">
        <newcomp></newcomp>
      </div>
      <br /><br />

      <!-- Your Score -->
      <div class="form-group">
        <label class="form-label" for="yourScore">Your score</label>
        <input class="form-input" type="number" id="yourScore" v-model="yourScore" min="0" />
      </div>
      <br />

      <!-- Your cards -->

      <!-- Your Score -->
      <div class="form-group">
        <label class="form-label" for="theirScore">Competitor score</label>
        <input class="form-input" type="number" id="theirScore" v-model="theirScore" min="0" />
      </div>
      <br />

      <!-- Their cards -->

      <!-- Type -->
      <div class="form-group">
        <label class="form-label" for="type">Type:</label>
        <select class="form-select" id="type" v-model="type">
          <option value="">Choose a type</option>
          <option value="practice">Practice</option>
          <option value="pool">Pool</option>
          <option value="de">Direct Elimination</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label" for="weapon">Weapon</label>
        <select class="form-select" id="weapon" v-model="weapon">
          <option value="">Choose a weapon</option>
          <option value="epee">Epee</option>
          <option value="foil">Foil</option>
          <option value="sabre">Sabre</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label" for="agegroup">Age Group</label>
        <select class="form-select" id="agegroup" v-model="agegroup">
          <option value="">None</option>
          <option value="y10">Y10</option>
          <option value="y12">Y12</option>
          <option value="y14">Y14</option>
          <option value="cadet">Cadet</option>
          <option value="junior">Junior</option>
          <option value="senior">Senior</option>
          <option value="veteran">Veteran</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label" for="gender">Gender</label>
        <select class="form-select" id="gender" v-model="gender">
          <option value="mixed">Mixed</option>
          <option value="women">Women</option>
          <option value="men">Men</option>
        </select>
      </div>

      <!-- Notes -->
      <div class="form-group">
        <label class="form-label" for="notes">Notes</label>
        <textarea class="form-input" id="notes" v-model="notes" rows="3"></textarea>
      </div>
      <br />

      <div class="actions">
        <button type="reset" class="btn">Reset</button>&nbsp;
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
  import { EventBus } from '@/main'
  import config from "@/config"
  import newcomp from '@/components/competitorForm'
  import newevent from '@/components/eventForm'
  import alert from "@/components/Alert"

  export default {
    name : "boutform",
    components : {
      newcomp,
      newevent,
      alert
    },
    props : [
      "competitors",
      "events",
      "me"
    ],
    data () {
      return {
        competitor : null,
        event : "",
        yourScore : 0,
        theirScore : 0,
        notes : "",
        showCompetitor : "none",
        showEvent : "none",
        type : "",
        weapon : "",
        agegroup : "",
        gender : "mixed",
        showAlert : "",
        alertTitle : "",
        alertType : "",
        alertContent : "",
        date : ""
      }
    },
    methods : {
      submit: function(e){
        // TODO: do some error checking here
        if(this.competitor == "" || this.competitor == null){
          this.showAlert = "shown"
          this.alertTitle = "Error"
          this.alertContent = "You need to enter a competitor to save a bout."
          this.alertType = "error"
        } else {
          fetch(config.baseUrl+"scores/create", {
            method : "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            credentials : "include",
            body : JSON.stringify({
              event : this.event,
              date : this.date,
              fencerone : this.me.id,
              fencertwo : this.competitor,
              compscore : this.theirScore,
              compcards : "",
              compvictory : this.theirScore > this.yourScore ? true : false,
              youscore : this.yourScore,
              youcards : "",
              youvictory : this.yourScore > this.theirScore ? true : false,
              type : this.type,
              period : "",
              weapon : this.weapon,
              age : this.agegroup,
              gender : this.gender,
              notes : this.notes
            })
          }).then(e => {
            return e.json()
          }).then(j => {
            if(j.error){
              this.showAlert = "shown"
              this.alertTitle = "Error"
              this.alertContent = j.error
              this.alertType = "error"
            } else {
              // reset form and fire off an alert
              this.showAlert = "shown"
              this.alertTitle = "Bout saved!"
              this.alertContent = "You successfully added your bout! Go to the dashboard to view your scores or enter another bout!"
              this.alertType = "success"

              // reset form
              let form = document.getElementById("boutForm")
              form.reset()
            }
          })
        }
      },
      newCompetitor : function(e){
        if(this.showCompetitor == "none"){
          this.showCompetitor = "block"
        } else {
          this.showCompetitor = "none"
        }
      },
      newEvent : function(e){
        if(this.showEvent == "none"){
          this.showEvent = "block"
        } else {
          this.showEvent = "none"
        }
      },
      changeEvent : function(e){
        this.events.forEach(event => {
          if(event.id == this.event){
            this.date = event.date.split("T")[0]
          }
        })
      }
    },
    created (){
      EventBus.$on("newCompetitor", (data) => {
        this.showCompetitor = "none"
        this.competitor = data.originalid ? data.originalid : data.id
      })

      EventBus.$on("newEvent", (data) => {
        this.showEvent = "none"
        this.event = data.id
      })

      EventBus.$on("hideAlert", () => {
        this.showAlert = ""
      })

    }
  }
</script>

<style lang="scss">
  .boutentry {
    padding-right: 20px;
    .actions {
      text-align: right;
      margin-bottom: 40px;
    }
  }
</style>
